import { useTranslation } from 'react-i18next';
import { Star, ExternalLink, MapPin, Navigation } from 'lucide-react';

const STRENGTH_NL = {
  "experienced team": "ervaren team", "experienced technicians": "ervaren technici", "experienced staff": "ervaren medewerkers",
  "experienced installers": "ervaren installateurs", "experienced professionals": "ervaren vakmensen", "experience": "ervaring",
  "excellent customer service": "uitstekende klantenservice", "customer service": "klantenservice", "good customer service": "goede klantenservice",
  "strong customer service": "sterke klantenservice", "quality customer service": "kwalitatieve klantenservice",
  "reliable customer service": "betrouwbare klantenservice", "excellent customer support": "uitstekende klantenondersteuning",
  "comprehensive energy solutions": "uitgebreide energieoplossingen", "diverse energy solutions": "diverse energieoplossingen",
  "sustainable energy solutions": "duurzame energieoplossingen", "wide range of energy solutions": "breed scala aan energieoplossingen",
  "comprehensive service": "uitgebreide service", "comprehensive services": "uitgebreide diensten",
  "comprehensive solutions": "uitgebreide oplossingen", "comprehensive service offerings": "uitgebreid dienstenpakket",
  "personalized service": "persoonlijke service", "professional service": "professionele service", "reliable service": "betrouwbare service",
  "customer satisfaction": "klanttevredenheid", "high customer satisfaction": "hoge klanttevredenheid",
  "high customer ratings": "hoge klantbeoordelingen", "customer focus": "klantgerichtheid",
  "competitive pricing": "scherpe prijzen", "affordable pricing": "betaalbare prijzen", "affordable packages": "betaalbare pakketten",
  "quick installation": "snelle installatie", "efficient installation": "efficiënte installatie", "efficient installations": "efficiënte installaties",
  "high-quality installations": "hoogwaardige installaties", "reliable installations": "betrouwbare installaties",
  "custom solutions": "maatwerkoplossingen", "customized solutions": "maatwerkoplossingen", "innovative solutions": "innovatieve oplossingen",
  "eco-friendly solutions": "milieuvriendelijke oplossingen", "eco-friendly materials": "milieuvriendelijke materialen",
  "eco-friendly systems": "milieuvriendelijke systemen", "sustainable practices": "duurzame werkwijzen",
  "sustainability focus": "focus op duurzaamheid", "sustainable technology": "duurzame technologie",
  "high-quality products": "hoogwaardige producten", "high quality products": "hoogwaardige producten",
  "high-quality materials": "hoogwaardige materialen", "quality materials": "kwalitatieve materialen",
  "local expertise": "lokale expertise", "expertise": "expertise", "technical expertise": "technische expertise",
  "expert installation": "deskundige installatie", "expert consultation": "deskundig advies",
  "knowledgeable staff": "deskundig personeel", "qualified staff": "gekwalificeerd personeel",
  "professional team": "professioneel team", "friendly staff": "vriendelijk personeel",
  "family business": "familiebedrijf", "family-owned business": "familiebedrijf",
  "free consultations": "gratis adviesgesprekken", "energy consulting": "energieadvies",
  "fast service": "snelle service", "quick service": "snelle service",
  "well-established": "gevestigd bedrijf", "strong local reputation": "sterke lokale reputatie",
  "strong regional presence": "sterke regionale aanwezigheid", "strong community presence": "sterke lokale betrokkenheid",
  "range of services": "divers dienstenaanbod", "wide range of services": "breed dienstenaanbod",
  "broad service range": "breed serviceaanbod", "cutting-edge technology": "geavanceerde technologie",
  "focus on sustainable solutions": "focus op duurzame oplossingen",
  "Expertise in geothermal technology": "expertise in geothermische technologie",
  "Expertise in solar energy solutions": "expertise in zonne-energieoplossingen",
  "Comprehensive energy solutions": "uitgebreide energieoplossingen",
  "Comprehensive home installation services": "uitgebreide woninginstallatiediensten",
  "Comprehensive service": "uitgebreide service",
  "Experienced in energy-efficient solutions": "ervaren in energiezuinige oplossingen",
  "Experienced installation team": "ervaren installatieteam",
  "Experienced team": "ervaren team",
  "Strong customer service": "sterke klantenservice",
  "Strong reputation in solar installations": "sterke reputatie in zonne-installaties",
  "Focus on sustainable energy solutions": "focus op duurzame energieoplossingen",
  "Focused on eco-friendly energy solutions": "gericht op milieuvriendelijke energieoplossingen",
  "Free consultations": "gratis adviesgesprekken",
  "High customer satisfaction": "hoge klanttevredenheid",
  "High-quality installations": "hoogwaardige installaties",
  "Innovative financing solutions": "innovatieve financieringsoplossingen",
  "Local expertise": "lokale expertise",
  "Personalized service": "persoonlijke service",
  "Quick installation": "snelle installatie",
  "Reliable customer service": "betrouwbare klantenservice",
  "Responsive support team": "responsief supportteam",
  "Sustainable energy focus": "focus op duurzame energie",
  "Sustainable materials": "duurzame materialen",
  "Wide range of solar products": "breed assortiment zonnepanelen",
  "Customer service": "klantenservice",
  "Customized solutions": "maatwerkoplossingen",
  "Diverse energy solutions": "diverse energieoplossingen",
  "Environmentally conscious": "milieubewust",
  "Environmentally friendly products": "milieuvriendelijke producten",
  "Excellent after-sales service": "uitstekende after-salesservice",
  "Community solar projects": "gemeenschappelijke zonneprojecten",
  "Competitive pricing": "scherpe prijzen",
  "Custom solutions for residential homeowners": "maatwerkoplossingen voor woningeigenaren",
  "High volume of customer reviews": "groot aantal klantbeoordelingen",
  "Local service in Noord-Brabant": "lokale service in Noord-Brabant",
  "Operates locally in Noord-Brabant": "actief in Noord-Brabant",
  "specialized in heat pump technology": "gespecialiseerd in warmtepomptechnologie",
  "specializes in renewable energy": "gespecialiseerd in duurzame energie",
  "expertise in heating solutions": "expertise in verwarmingsoplossingen",
  "specialized focus": "gespecialiseerde focus",
  "specializes in both heat pump and ventilation systems": "gespecialiseerd in warmtepomp- en ventilatiesystemen",
  "experienced in solar and heat pump installations": "ervaren in zonne- en warmtepompinstallaties",
  "experienced in a wide range of insulation projects": "ervaren in diverse isolatieprojecten",
  "comprehensive construction and insulation services": "uitgebreide bouw- en isolatiediensten",
  "comprehensive renovation services": "uitgebreide renovatiediensten",
  "comprehensive energy assessment": "uitgebreide energiebeoordeling",
  "committed to energy efficiency": "toegewijd aan energiebesparing",
  "energy efficiency audits": "energiebesparingsaudits",
  "strong focus on energy efficiency": "sterke focus op energiebesparing",
  "co-operative business model": "coöperatief bedrijfsmodel",
  "bespoke designs": "ontwerp op maat",
  "custom designs": "ontwerp op maat",
  "custom installations": "installatie op maat",
  "customized solar solutions": "zonneoplossingen op maat",
  "customer-focused service": "klantgerichte service",
  "customer-tailored solutions": "oplossingen op maat",
  "natural insulation materials": "natuurlijke isolatiematerialen",
  "innovation in materials": "innovatie in materialen",
  "tailored insulation solutions": "isolatieoplossingen op maat",
  "high-quality panels": "hoogwaardige panelen",
  "solid technical expertise": "gedegen technische expertise",
  "quality seal": "kwaliteitskeurmerk",
  "timely completion": "tijdige oplevering",
  "trusted regional supplier": "betrouwbare regionale leverancier",
  "positive client feedback": "positieve klantbeoordelingen",
  "personalized approach": "persoonlijke aanpak",
  "sustainable building practices": "duurzame bouwpraktijken",
  "strong technical support": "sterke technische ondersteuning",
};

function translateStrength(s, lang) {
  if (lang !== 'nl') return s;
  const key = s.trim();
  if (STRENGTH_NL[key]) return STRENGTH_NL[key];
  // Lowercase lookup
  const lower = key.toLowerCase();
  for (const [k, v] of Object.entries(STRENGTH_NL)) {
    if (k.toLowerCase() === lower) return v;
  }
  return s;
}

function InstallerCard({ ins, lang }) {
  const websiteLabel = lang === 'nl' ? 'Website' : lang === 'de' ? 'Webseite' : 'Website';

  return (
    <div data-testid={`installer-${ins.installer_id}`} className="flex items-start justify-between gap-3 bg-muted/30 rounded-lg px-4 py-3">
      <div className="min-w-0">
        <p className="text-sm font-medium">{ins.company_name}</p>
        <div className="flex items-center gap-2 text-xs text-muted-foreground mt-0.5">
          <MapPin className="w-3 h-3" />
          <span>{ins.city}, {ins.region}</span>
          {ins.specializations?.length > 1 && (
            <span className="ml-1">· {ins.specializations.map(s => s.replace(/_/g, ' ')).join(', ')}</span>
          )}
        </div>
        {ins.strengths?.length > 0 && (
          <p className="text-xs text-green-700 mt-1">+ {translateStrength(ins.strengths[0], lang)}</p>
        )}
      </div>
      <div className="flex items-center gap-3 flex-shrink-0">
        {ins.review_score && (
          <span className="flex items-center gap-0.5 text-amber-600 text-xs">
            <Star className="w-3 h-3 fill-amber-400" />
            {ins.review_score}
            {ins.review_count && <span className="text-muted-foreground">({ins.review_count})</span>}
          </span>
        )}
        {ins.website && (
          <a href={ins.website} target="_blank" rel="noopener noreferrer"
            className="text-primary hover:underline flex items-center gap-0.5 text-xs">
            {websiteLabel} <ExternalLink className="w-3 h-3" />
          </a>
        )}
      </div>
    </div>
  );
}

function InstallerGroup({ title, installers, icon: Icon, badge, lang }) {
  if (!installers || installers.length === 0) return null;

  const grouped = {};
  for (const ins of installers) {
    const spec = ins.specializations?.[0] || 'general';
    if (!grouped[spec]) grouped[spec] = [];
    grouped[spec].push(ins);
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        {Icon && <Icon className="w-4 h-4 text-primary" />}
        <h4 className="text-sm font-semibold">{title}</h4>
        {badge && (
          <span className="text-[10px] px-2 py-0.5 rounded-full bg-primary/10 text-primary font-medium">
            {badge}
          </span>
        )}
      </div>
      {Object.entries(grouped).map(([spec, companies]) => (
        <div key={spec}>
          <p className="text-xs font-medium capitalize text-muted-foreground mb-1.5 ml-1">{spec.replace(/_/g, ' ')}</p>
          <div className="space-y-2">
            {companies.map(ins => <InstallerCard key={ins.installer_id} ins={ins} lang={lang} />)}
          </div>
        </div>
      ))}
    </div>
  );
}

export default function InstallersSection({ localInstallers, otherInstallers, userRegion, installers }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || 'en';

  const hasRegionalData = localInstallers || otherInstallers;
  const local = localInstallers || [];
  const other = otherInstallers || [];
  const allInstallers = hasRegionalData ? [...local, ...other] : (installers || []);

  if (allInstallers.length === 0) return null;

  const sourceLabel = lang === 'nl' ? 'Bron' : 'Source';
  const companiesLabel = lang === 'nl' ? 'bedrijven' : lang === 'de' ? 'Unternehmen' : 'companies';
  const inRegionLabel = userRegion
    ? (lang === 'nl' ? `In ${userRegion}` : `In ${userRegion}`)
    : (lang === 'nl' ? 'In uw regio' : t('report.inYourRegion', 'In Your Region'));
  const otherRegionsLabel = lang === 'nl' ? 'Overige regio\'s' : t('report.otherRegions', 'Other Regions');
  const allRegionsLabel = lang === 'nl' ? 'Alle regio\'s' : t('report.allRegions', 'All Regions');
  const sourceName = allInstallers[0]?.source_name;

  return (
    <div className="bg-white rounded-xl border border-border shadow-sm p-5" data-testid="installers-section">
      <h3 className="text-base font-semibold mb-1" style={{ fontFamily: 'Outfit' }}>
        {t('report.localProfessionals')}
      </h3>
      <p className="text-xs text-muted-foreground mb-4">
        {t('report.installersDisclaimer')}
      </p>

      <div className="space-y-6">
        {hasRegionalData && local.length > 0 ? (
          <>
            <InstallerGroup
              title={inRegionLabel}
              installers={local}
              icon={Navigation}
              badge={`${local.length} ${companiesLabel}`}
              lang={lang}
            />
            {other.length > 0 && (
              <div className="border-t border-border/50 pt-4">
                <InstallerGroup
                  title={otherRegionsLabel}
                  installers={other}
                  icon={MapPin}
                  lang={lang}
                />
              </div>
            )}
          </>
        ) : (
          <InstallerGroup
            title={allRegionsLabel}
            installers={allInstallers}
            icon={MapPin}
            lang={lang}
          />
        )}
      </div>

      {sourceName && (
        <p className="text-[10px] text-muted-foreground mt-3">{sourceLabel}: {sourceName}</p>
      )}
    </div>
  );
}
